import React from 'react';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { IconInvoice } from '../../../../../shared/Icons';
import { Link } from 'react-router-dom';
import { MUTED_TEXT_COLOR } from '../../../../../utils/constants';
import { useTranslation } from 'react-i18next';

interface IInvoiceCard {
    myOffers: any;
    isAgency: boolean;
}

export default function InvoiceCard({ myOffers, isAgency }: IInvoiceCard) {
    const { t } = useTranslation();
    return (
        <CardLayout classCard="h-100">
            <div className="pr-0 d-flex flex-column justify-content-between h-100">
                <h6 className="text-muted d-flex align-items-center">
                    <IconInvoice width="20" height="20" color={MUTED_TEXT_COLOR} classes="mr-2" />
                    <div>{t('influencer.profile.invoices')}</div>
                </h6>
                <div className="d-flex align-items-center justify-content-between mt-1">
                    <div>
                        <h5 className="text-primary mb-0">{myOffers?.availableInvoices ?? 0}</h5>
                        <span>{t('influencer.dashboard.available_invoices')}</span>
                    </div>
                    <Link
                        to={isAgency ? '/agency/invoices' : '/influencer/invoices'}
                        className={`btn btn-outline-primary`}
                    >
                        {t('influencer.dashboard.see_all')}
                    </Link>
                </div>
            </div>
        </CardLayout>
    );
}
